import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/Login";
import Register from "../pages/Register";
import Dashboard from "../pages/Dashboard";
import ProjectList from "../pages/project/ProjectList";
import ProjectCreate from "../pages/project/ProjectCreate";
import ProjectUpdate from "../pages/project/ProjectUpdate";
import ProjectDelete from "../pages/project/ProjectDelete";
import ProjectStatus from "../pages/project/ProjectStatus"; // Asegúrate de importar el nuevo componente
import KanbanBoard from "../pages/project/KanbanBoard";

import TestList from "../pages/tests/TestList";
import TestListXProject from "../pages/tests/TestListXProject";
import TestCreate from "../pages/tests/TestCreate";
import TestUpdate from "../pages/tests/TestUpdate";
import TestDelete from "../pages/tests/TestDelete";

import UserList from "../pages/users/UserList";
import UserCreate from "../pages/users/UserCreate";
import UserUpdate from "../pages/users/UserUpdate";
import UserDelete from "../pages/users/UserDelete";

import DefectList from "../pages/defects/DefectList";
import DefectCreate from "../pages/defects/DefectCreate";
import DefectUpdate from "../pages/defects/DefectUpdate";

import ProtectedRoute from "../context/ProtectedRoute"; // Ruta protegida

const Router = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Rutas protegidas por autenticación */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      >
        <Route path="projects" element={<ProjectList />} />
        <Route path="project-status" element={<ProjectStatus />} />
        <Route path="kanban" element={<KanbanBoard />} />
        <Route path="projects/create" element={<ProjectCreate />} />
        <Route path="projects/update/:id" element={<ProjectUpdate />} />
        <Route path="projects/delete/:id" element={<ProjectDelete />} />

        <Route
          path="projects/:projectId/tests"
          element={<TestListXProject />}
        />
        <Route
          path="projects/:projectId/tests/create"
          element={<TestCreate />}
        />
        <Route
          path="projects/:projectId/tests/update/:testId"
          element={<TestUpdate />}
        />
        <Route
          path="projects/:projectId/tests/delete/:testId"
          element={<TestDelete />}
        />

        <Route path="tests" element={<TestList />} />

        <Route path="users" element={<UserList />} />
        <Route path="users/create" element={<UserCreate />} />
        <Route path="users/update/:id" element={<UserUpdate />} />
        <Route path="users/delete/:id" element={<UserDelete />} />

        <Route path="defects" element={<DefectList />} />
        <Route path="defects/create" element={<DefectCreate />} />
        <Route path="defects/update/:id" element={<DefectUpdate />} />
      </Route>

      {/* Redirige a login si el path no coincide */}
      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
};

export default Router;
